import { createContext, useContext } from "react";

interface IDndDataTableContext {
  enableDragAndDrop: boolean;
}

const defaultDndDataTableContext: IDndDataTableContext = {
  enableDragAndDrop: false,
};

export const DndDataTableContext = createContext<IDndDataTableContext>(defaultDndDataTableContext);
export const useDndDataTableContext = () => useContext(DndDataTableContext);
